import CustomDialog from 'components/CustomDialog';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import CustomTextField from 'components/Input/CustomTextField';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import { checkNull } from 'utility/formValidate';
import { produce } from 'utility/general';
import { CCO } from 'utility/lookup';

const SLayout = styled.div``;

const ConfirmModal = ({ onCancel = () => null, isShow = false, onSubmit = () => null, applicationDetail = {}, }) => {
    const [comment, setComment] = useState('');
    const [workflow, setWorkflow] = useState(applicationDetail.applicationForm.irbFlow);
    const [validations, setValidation] = useState({});
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);
    const user = useSelector((state) => state.user);

    const [irbNo, setIRBNo] = useState('');

    useEffect(() => {
        if (isShow) {
            setComment('');
            setWorkflow(applicationDetail.applicationForm.irbFlow);
            setIRBNo('');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShow]);

    return (
        <SLayout>
            <CustomDialog
                title={'Are you sure to confirm the application?'}
                isShow={isShow}
                onCancel={onCancel}
                showUploadButton
                onConfirm={({ files }) => {
                    const isValid = Object.values(validations).every((item) => item);

                    if (!isValid) {
                        setForceErrorDisplay(true);
                        return;
                    }

                    onSubmit({
                        irbNo,
                        irbFlow: workflow,
                        comment,
                        files,
                    });
                }}
            >
                {user.role === CCO && (
                    <>
                        <div>Select your flow:</div>
                        <div style={{ marginTop: 10 }}>
                            <CustomOutlineSelect
                                name={'workflow'}
                                disabled={!checkNull(applicationDetail.applicationForm.irbFlow)}
                                forceErrorDisplay={forceErrorDisplay}
                                isRequired
                                isValidValue={(isValid) => {
                                    setValidation(
                                        produce((draft) => {
                                            draft.workflow = isValid;
                                        }),
                                    );
                                }}
                                onChange={(e) => {
                                    setWorkflow(e.target.value);
                                }}
                                value={workflow}
                                choices={[
                                    {
                                        key: 0,
                                        display: 'Central IRB(Routine Panel)',
                                    },
                                    {
                                        key: 1,
                                        display: 'Central IRB(PAED Panel)',
                                    },
                                ]}
                            />
                        </div>
                    </>
                )}

                <div style={{ marginTop: 15 }}>
                    <CustomTextField
                        name={'irbNo'}
                        maxLength={255}
                        value={irbNo}
                        label={`IRB/ REC Reference No. ${user.role === CCO ? '(optional)' : ''}`}
                        onChange={(e) => {
                            setIRBNo(e.target.value);
                        }}
                        validators={user.role === CCO ? [] : ['isRequired']}
                        forceErrorDisplay={forceErrorDisplay}
                        isValidValue={(isValid) => {
                            setValidation(
                                produce((draft) => {
                                    draft.irbNo = isValid;
                                }),
                            );
                        }}
                    />
                </div>

                <div style={{ marginTop: 15 }}>
                    <CustomTextField
                        name={'comment'}
                        forceErrorDisplay={forceErrorDisplay}
                        // validators={['isRequired']}
                        isValidValue={(isValid) => {
                            setValidation(
                                produce((draft) => {
                                    draft.comment = isValid;
                                }),
                            );
                        }}
                        maxLength={255}
                        value={comment}
                        onChange={(e) => {
                            setComment(e.target.value);
                        }}
                        isTextArea
                        placeholder="Leave your comments (if any)"
                    />
                </div>
            </CustomDialog>
        </SLayout>
    );
};

export default ConfirmModal;
